module.exports = __webpack_public_path__ + "img/work_from_anywhere3.988e4558.png";